import { ReactNode } from 'react';

import { cn } from '../../../helpers/shadCnUtils';

interface MainPageWrapperProps {
  children: ReactNode;
  className?: string;
}

export const MainPageWrapper = ({ children, className }: MainPageWrapperProps) => {
  return (
    <div className="flex h-full w-full flex-col">
      <div className={cn('h-full w-full overflow-y-auto bg-white px-6 py-4', className)}>{children}</div>
    </div>
  );
};
